import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { CompleteYourLookLookRepositoryImpl } from "../../domain/completeYourLookLookRepository/CompleteYourLookLookRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const lookRepo = CompleteYourLookLookRepositoryImpl.getInstance();

const useGetCompleteYourLookLooks = (anchorProductVariantId?: string) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["useGetCompleteYourLookLooks", anchorProductVariantId],
      queryFn: async () => {
        return await lookRepo.get(auth, anchorProductVariantId, apiUrl);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return { looks: data, isLoading };
};

export { useGetCompleteYourLookLooks };
